<div class="autocomplete-container">
  <div
    class="input-group"
    #searchContainer
    [class.small-lookup-field]="
      ['scheduleClientLookupFieldId', 'scheduleUserLookupFieldId'].includes(
        inputId
      )
    "
  >
    <div class="form-floating">
      <input
        class="form-control"
        #searchInput
        type="text"
        placeholder="{{ placeHolder }}"
        [(ngModel)]="query"
        (input)="onChange($event)"
        (focus)="handleFocus($event)"
        (keyup.enter)="inputSubmitted()"
        [id]="inputId"
        [maxlength]="maxLength"
        autocomplete="false"
        autocomplete="off"
      />
      <label>{{ placeHolder }}</label>
    </div>
    @if (query && enableSearchCloseOption) {
      @if (!hideSearchButton) {
        <span class="input-group-text" (click)="inputSubmitted()">
          <i class="fa-solid fa-magnifying-glass"></i>
        </span>
      }
      <span class="input-group-text" (click)="onCloseSearch()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    }
    @if (query && enableCloseOption) {
      <span class="input-group-text" (click)="onCloseSearch()">
        <i class="fa-solid fa-delete-left"></i>
      </span>
    }
  </div>
  <!--FilteredList items-->
</div>
<ng-template #overlayTemplate>
  @if (isFocused && filteredList?.length) {
    <div
      #suggestionsContainer
      class="suggestions-container border border-2 border-secondary shadow-lg rounded bg-body text-body"
      [ngStyle]="{
        'width': inputBoxWidth,
        'max-height': additionalConfig?.containerHeightMax || '20rem',
      }"
    >
      <div #filteredListElement>
        @for (item of filteredList; track item; let idx = $index) {
          <div
            class="item"
            [ngClass]="{
              'text-uppercase fw-bolder text-primary rounded py-3':
                idx === 0 && item?.key === 0,
            }"
            (click)="selectDropDownOption(item)"
          >
            <div [class.complete-selected]="idx === selectedIdx">
              <ng-container
                *ngTemplateOutlet="
                  itemTemplate;
                  context: {
                    $implicit: item,
                  }
                "
              >
              </ng-container>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
